console.log('MindsSDK Loyalty initialized');

window.sdk = new MindsSDK.LoyaltyPage({
  apiKey: 'key_live_nTOuUWJxYHY2qaP3HdjS0QsTcaLpameKWL7LvynqYmw',
  platform: 'SHOPIFY',
  shopDomain: 'a22b64-29.myshopify.com',
  useAppProxy: true, // Default is true for Shopify
});

// Function to update loyalty UI (main balance display + the "Points to Redeem" tab label share this hook)
function updateLoyaltyUI(pointsBalance) {
  const pointsElements = document.querySelectorAll('[data-points-balance]');
  pointsElements.forEach((element) => {
    element.textContent = pointsBalance;
  });
}

// Function to update VIP tier display (rendered both in the membership header and the redemption tab)
function updateVipTierDisplay(vipTier) {
  const tierElements = document.querySelectorAll('[data-vip-tier]');
  tierElements.forEach((tierElement) => {
    const tierNameElement = tierElement.querySelector('[data-vip-tier-name]');
    if (vipTier) {
      if (tierNameElement) {
        tierNameElement.textContent = vipTier;
      }
      tierElement.style.display = 'inline';
    } else {
      tierElement.style.display = 'none';
    }
  });
}

// Sync birthday to 99minds
async function syncBirthdayToMinds(dateOfBirth) {
  try {
    const sdk = await window.sdk.onReady();
    await sdk.resource.postUpdateCustomer({
      customer: { birthday_str: dateOfBirth },
    });
    console.log('✅ Birthday synced to 99minds:', dateOfBirth);
  } catch (error) {
    console.error('Failed to sync birthday to 99minds:', error);
  }
}

// Ensure customer is opted into loyalty program and sync birthday
async function ensureLoyaltyOptIn() {
  try {
    const sdk = await window.sdk.onReady();
    const response = await sdk.resource.postCustomer();

    const customerInfo = response?.data?.customer || {};

    console.log('🧑 Customer Info:', customerInfo);

    if (!customerInfo) {
      return null;
    }

    // Check if opt-in is needed
    const needsOptIn = !customerInfo.has_opted_in_loyalty;

    // Check if birthday sync is needed
    const shopifyBirthday = window.Shopify?.customerBirthday || null;
    const mindsBirthday = customerInfo.birthday_str || null;
    const needsBirthdaySync = shopifyBirthday && !mindsBirthday;

    console.log('🎂 Birthday sync check:', { shopifyBirthday, mindsBirthday, needsBirthdaySync });

    // Build combined update payload if anything needs syncing
    if (needsOptIn || needsBirthdaySync) {
      const updatePayload = {};
      if (needsOptIn) updatePayload.opt_in_loyalty = true;
      if (needsBirthdaySync) updatePayload.birthday_str = shopifyBirthday;

      await sdk.resource.postUpdateCustomer({
        customer: updatePayload,
      });

      if (needsOptIn) console.log('✅ Customer opted into loyalty');
      if (needsBirthdaySync) console.log('✅ Birthday synced to 99minds:', shopifyBirthday);
    }

    // Only run tagging + UI refresh when opt-in was needed
    if (needsOptIn) {
      // Tag customer in Shopify for segmentation
      const backendUrl = window.Shopify?.backendUrl;
      const storeIdentifier = window.Shopify?.storeIdentifier;
      const customerId = window.Shopify?.customerId;

      if (backendUrl && customerId) {
        try {
          await fetch(`${backendUrl}/api/customers/add-tags?store=${storeIdentifier}`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ customerId }),
          });
          console.log('Tagged customer as loyalty-opt-in:online-store');
        } catch (err) {
          console.error('Failed to tag customer:', err);
        }
      }

      // Wait 1 second and refetch customer info and points balance
      setTimeout(async () => {
        const newResponse = await sdk.resource.postCustomer();
        const pointsBalance = await sdk.resource.getPointsBalance();

        const refreshedCustomerInfo = newResponse?.data?.customer || {};

        console.log('🧑 Refreshed Customer Info:', refreshedCustomerInfo);
        console.log('🧑 Refreshed Points Balance:', pointsBalance);

        // Update UI with refreshed data
        const vipTier = refreshedCustomerInfo?.vip_tier?.name || null;
        updateVipTierDisplay(vipTier);

        if (pointsBalance?.data?.point_balance) {
          updateLoyaltyUI(pointsBalance.data.point_balance);
        } else {
          updateLoyaltyUI(0);
        }
      }, 1000);
    }

    return customerInfo?.vip_tier?.name || null;
  } catch (error) {
    console.error('Error checking/updating loyalty opt-in:', error);
    return null;
  }
}

// Fetch and update points
async function fetchAndUpdatePoints() {
  try {
    const sdk = await window.sdk.onReady();
    const pointsBalance = await sdk.resource.getPointsBalance();

    // Ensure opt-in and get VIP tier
    const vipTier = await ensureLoyaltyOptIn();

    const balanceValue = pointsBalance?.data?.point_balance || 0;
    updateLoyaltyUI(balanceValue);
    updateVipTierDisplay(vipTier);
    updateRedemptionCardsAvailability(balanceValue);

    return pointsBalance;
  } catch (error) {
    console.error('Error fetching points:', error);
    return null;
  }
}

// Disable "Redeem" CTAs for cards the customer can't currently afford
function updateRedemptionCardsAvailability(pointsBalance) {
  const redeemButtons = document.querySelectorAll('[data-redeem-button]');
  redeemButtons.forEach((button) => {
    const pointsRequired = Number(button.dataset.pointsRequired) || 0;
    button.disabled = pointsRequired > pointsBalance;
  });
}

// Fetch Points Transaction History
async function fetchPointsTransactionHistory() {
  try {
    const sdk = await window.sdk.onReady();
    const pointsTransactions = await sdk.resource.getPointsTransactions();

    return pointsTransactions;
  } catch (error) {
    console.error('Error fetching points transactions:', error);
    return null;
  }
}

// Raw rewards array, shared by getRewards() (renders the Available Rewards tab) and
// loadTransactionHistory() (matches a past redemption to the reward it created — see
// findRewardForTransaction). Confirmed against a live response (2026-07-29): rewards live at
// data.rewards. Deliberately doesn't catch its own errors — each caller decides how a fetch
// failure here should be handled (getRewards() treats it as a real error state; the transaction
// modal treats it as an optional enrichment that can degrade gracefully).
async function fetchRawRewards() {
  const sdk = await window.sdk.onReady();
  const rewards = await sdk.resource.getRewards();
  return rewards?.data?.rewards || [];
}

// Get rewards (available, currently-usable reward codes, rendered into the "Available Rewards" tab)
async function getRewards() {
  try {
    const rawRewards = await fetchRawRewards();

    // Also confirmed (via a real customer's redeemed order) that 99minds drops a coupon from this
    // list entirely once it's fully used, rather than flagging it inactive — so every reward
    // returned here is already guaranteed valid/copyable. The one thing not confirmed: whether an
    // expired-but-unused code is also dropped, or still returned — so that's filtered client-side
    // as cheap insurance. Sorted newest-first by created_at rather than trusting the API's own
    // ordering, so a fresh redemption always lands at the top of the list regardless of how
    // 99minds returns it.
    const rewardsList = rawRewards
      .filter((reward) => !(reward.expiration_date_timestamp && reward.expiration_date_timestamp * 1000 < Date.now()))
      .sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());

    renderRedemptionHistory(rewardsList);

    return rawRewards;
  } catch (error) {
    console.error('Error fetching rewards:', error);
    showRedemptionHistoryError();
    return null;
  }
}

// Debug helper: logs the raw, unprocessed 99minds API responses so the real field names/shapes
// can be confirmed against what this file currently guesses. Call from the browser console:
//   window.loyaltyUtils.logRawLoyaltyData()
// Best run right after redeeming a reward, and again after actually using a code at checkout, to
// see what (if anything) changes on the reward object.
async function logRawLoyaltyData() {
  const sdk = await window.sdk.onReady();
  console.log('rewards', JSON.stringify(await sdk.resource.getRewards(), null, 2));
  console.log('transactions', JSON.stringify(await sdk.resource.getPointsTransactions(), null, 2));
}

// Initialize when SDK is ready
document.addEventListener('MindsSDKInitialized', (event) => {
  const sdk = event.detail.sdk;
  fetchAndUpdatePoints();

  fetchPointsTransactionHistory();
  getRewards();
});

// Also try with Promise approach as fallback
fetchAndUpdatePoints();
fetchPointsTransactionHistory();
getRewards();

// ========================================
// Transaction History Modal
// ========================================

// Map transaction types to display text. REDEMPTION reads "Redeemed" rather than "Spent" —
// spending points only converts them into a reward code; it doesn't mean the code has actually
// been used at checkout yet. See findRewardForTransaction for how the reward name gets attached
// to disambiguate further.
const TRANSACTION_TYPE_MAP = {
  RELOAD: 'Earned',
  REDEMPTION: 'Redeemed',
  MANUAL_CREDIT: 'Earned',
  MANUAL_DEBIT: 'Spent',
  EXPIRED: 'Expired',
};

// Format date to match design: "Mar 21, 01:27 PM"
function formatTransactionDate(timestamp) {
  const date = new Date(timestamp);
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const month = months[date.getMonth()];
  const day = String(date.getDate()).padStart(2, '0');

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12 || 12;

  return `${month} ${day}, ${String(hours).padStart(2, '0')}:${minutes} ${ampm}`;
}

// Match a past REDEMPTION transaction to the reward it created, via transaction_timestamp ≈
// created_at (same 1-2 second correlation confirmed for the Available Rewards / My Codes list —
// see getRewardVariantId's neighboring comments). Once a reward is fully used, 99minds drops it
// from getRewards() entirely, so older, already-used redemptions won't find a match — this
// degrades to no reward name shown rather than a wrong one.
function findRewardForTransaction(transaction, rewards) {
  if (!Array.isArray(rewards) || !transaction.transaction_timestamp) return null;

  const transactionTime = new Date(transaction.transaction_timestamp).getTime();
  return (
    rewards.find(
      (reward) => reward.created_at && Math.abs(new Date(reward.created_at).getTime() - transactionTime) <= 5000
    ) || null
  );
}

// Create transaction item HTML
function createTransactionItem(transaction, rewards) {
  const actionText = TRANSACTION_TYPE_MAP[transaction.transaction_type] || 'Unknown';
  const formattedDate = formatTransactionDate(transaction.transaction_timestamp);

  // Determine if this is a credit (earned) or debit (spent/expired) transaction
  const isCreditTransaction = ['RELOAD', 'MANUAL_CREDIT'].includes(transaction.transaction_type);
  const iconClass = isCreditTransaction ? 'rewards-transaction-icon--credit' : 'rewards-transaction-icon--debit';

  const matchedReward = transaction.transaction_type === 'REDEMPTION' ? findRewardForTransaction(transaction, rewards) : null;
  const rewardLabel = matchedReward?.metadata?.customer_label;

  return `
    <div class="rewards-transaction-item">
      <div class="rewards-transaction-icon ${iconClass}">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
      <div class="rewards-transaction-details">
        <div class="rewards-transaction-amount">${actionText} ${transaction.amount} ⭐</div>
        <div class="rewards-transaction-date">${formattedDate}</div>
      </div>
    </div>
  `;
}

// Render transactions into the modal
function renderTransactions(transactions, rewards) {
  const listContainer = document.getElementById('rewards-transaction-list');
  const loadingContainer = document.getElementById('rewards-transaction-loading');
  const emptyContainer = document.getElementById('rewards-transaction-empty');

  if (!listContainer) {
    console.error('Transaction list container not found');
    return;
  }

  // Hide loading
  if (loadingContainer) loadingContainer.style.display = 'none';

  if (!transactions || transactions.length === 0) {
    // Show empty state
    if (emptyContainer) emptyContainer.style.display = 'block';
    return;
  }

  // Render transactions
  const transactionsHTML = transactions.map((transaction) => createTransactionItem(transaction, rewards)).join('');
  listContainer.innerHTML = transactionsHTML;
  listContainer.style.display = 'flex';
}

// Show error state
function showTransactionError() {
  const listContainer = document.getElementById('rewards-transaction-list');
  const loadingContainer = document.getElementById('rewards-transaction-loading');
  const emptyContainer = document.getElementById('rewards-transaction-empty');
  const errorContainer = document.getElementById('rewards-transaction-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (listContainer) listContainer.style.display = 'none';
  if (emptyContainer) emptyContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'block';
}

// Fetch and display transaction history
async function loadTransactionHistory() {
  try {
    // Fetch transaction data
    const response = await fetchPointsTransactionHistory();

    const transactionsData = response?.data?.points_transactions;

    // Reward-name enrichment is optional context, not core content — a failure here shouldn't
    // block the transaction list itself, so it degrades to no reward names rather than an error.
    const rewards = await fetchRawRewards().catch(() => []);

    renderTransactions(transactionsData, rewards);
  } catch (error) {
    console.error('Error loading transaction history:', error);
    showTransactionError();
  }
}

// Initialize transaction history modal
function initRewardsHistory() {
  const openButton = document.querySelector('[data-open-rewards-history]');
  const modal = document.getElementById('rewards-transaction-history-modal');

  if (!openButton || !modal) {
    console.warn('Rewards history button or modal not found');
    return;
  }

  // Add click handler to button
  openButton.addEventListener('click', (e) => {
    e.preventDefault();

    // Reset to loading state
    const listContainer = document.getElementById('rewards-transaction-list');
    const loadingContainer = document.getElementById('rewards-transaction-loading');
    const emptyContainer = document.getElementById('rewards-transaction-empty');
    const errorContainer = document.getElementById('rewards-transaction-error');

    if (listContainer) {
      listContainer.style.display = 'none';
      listContainer.innerHTML = '';
    }
    if (loadingContainer) loadingContainer.style.display = 'flex';
    if (emptyContainer) emptyContainer.style.display = 'none';
    if (errorContainer) errorContainer.style.display = 'none';

    // Open modal
    modal.show();

    // Load transactions
    loadTransactionHistory();
  });
}

// Initialize transaction history when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRewardsHistory);
} else {
  initRewardsHistory();
}

// ========================================
// Redemption Tab (Choose Your Reward / My Codes)
// ========================================

// Minimal HTML escaping for dynamic SDK content interpolated via innerHTML below
function escapeHtml(value) {
  const div = document.createElement('div');
  div.textContent = value === null || value === undefined ? '' : String(value);
  return div.innerHTML;
}

// A reward only carries an unambiguous product to add to cart when 99minds' coupon rule ties it
// to exactly one variant (confirmed shape: metadata.variant_ids is an array of {value: [...]}
// entries). Coupon types with no linked product (e.g. a flat order discount) return null here, as
// does the (currently unseen) case of a rule spanning multiple eligible variants — guessing which
// one the customer wants would be worse than not adding anything.
function getRewardVariantId(reward) {
  const entries = reward.metadata?.variant_ids;
  if (!Array.isArray(entries) || entries.length !== 1) return null;

  const values = entries[0]?.value;
  if (!Array.isArray(values) || values.length !== 1) return null;

  return values[0] || null;
}

// Add a variant to the cart and open the theme's cart drawer, mirroring the exact sequence the
// theme's own product-form add-to-cart flow uses (assets/theme.js, ProductForm): collect section
// IDs any cart-aware element wants bundled, request them from /cart/add.js, then dispatch the same
// cart:change event the drawer listens for. onSuccessDo: 'force_open_drawer' forces the drawer
// open regardless of the theme's general cart-type setting (page vs. drawer), since this specific
// interaction always wants the drawer.
async function addVariantToCartAndOpenDrawer(variantId) {
  const root = window.Shopify?.routes?.root || '/';

  const sectionsToBundle = [];
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } })
  );

  const response = await fetch(`${root}cart/add.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionsToBundle.join(',') }),
  });

  const responseJson = await response.json();

  if (!response.ok) {
    throw new Error(responseJson?.description || 'Could not add product to cart');
  }

  const cartContent = await (await fetch(`${root}cart.js`)).json();
  cartContent.sections = responseJson.sections;

  document.documentElement.dispatchEvent(
    new CustomEvent('cart:change', {
      bubbles: true,
      detail: { baseEvent: 'variant:add', onSuccessDo: 'force_open_drawer', cart: cartContent },
    })
  );
}

// Silently queue a discount code onto the session via Shopify's standard /discount/{code} link
// mechanism — there's no Ajax equivalent for applying a code, since that's tied to checkout/session
// state rather than the cart. Used via fetch() rather than a real navigation specifically so the
// customer isn't sent anywhere; this still needs a live click-test, since setting the cookie this
// way (vs. a real top-level navigation) hasn't been verified against this store.
async function applyDiscountCode(code) {
  const response = await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart`, {
    credentials: 'same-origin',
  });

  if (!response.ok) {
    throw new Error('Could not apply code');
  }
}

// Merchant-editable copy/destination for the "code applied, go shop" alert (see
// handleApplyCodeClick) — read from data attributes set by section settings on the redemption tab,
// since there's no single "browse everything" destination or wording that's correct for every store.
function getAppliedCodeSettings() {
  const tab = document.querySelector('.redemption-tab');
  return {
    message: tab?.dataset.appliedMessage || 'Your code is ready. Shop now and it will auto-apply at checkout.',
    shopNowLabel: tab?.dataset.shopNowLabel || 'Shop Now',
    shopNowUrl: tab?.dataset.shopNowUrl || '/collections/coffee',
  };
}

// Merchant-editable label for the product-linked "add to cart + apply code" button. Only used for
// that variant — the order-level "Apply Code" button (no product attached) keeps its own fixed
// label, since "Add to Cart" would misdescribe a code that has nothing to add.
function getUseRewardLabel() {
  return document.querySelector('.redemption-tab')?.dataset.useRewardLabel || 'Apply code + Add to Cart';
}

// Create a single "Available Rewards" list item (a currently-usable reward code)
//
// Confirmed against a live response (2026-07-29), including a real customer's redeemed order:
// getRewards() only ever returns currently-usable codes — 99minds drops a coupon from this list
// entirely once fully used rather than flagging it inactive. So every reward reaching this
// function is guaranteed valid; there's no used/inactive state to render.
function createRedemptionHistoryItem(reward) {
  const code = reward.code || '';
  const headline = reward.metadata?.customer_label || 'Reward';
  const image = reward.metadata?.coupon_image_url || reward.metadata?.free_product_image || '';
  const expiryText = reward.formatted_expiration_date || 'Does not expire';
  const variantId = getRewardVariantId(reward);

  const media = image
    ? `<div class="redemption-history-item__media"><img src="${escapeHtml(image)}" alt="${escapeHtml(headline)}" loading="lazy"></div>`
    : '';

  // A linked product (e.g. a free-item reward) can be force-added to cart before navigating, so
  // there's guaranteed to be something for the code to apply against. An order-level discount (no
  // product) has no such guarantee — applying it silently and staying put avoids sending the
  // customer to a cart that may currently be empty.
  const primaryAction = variantId
    ? `<button
        type="button"
        class="button redemption-history-use-button"
        data-use-reward
        data-reward-code="${escapeHtml(code)}"
        data-reward-variant-id="${escapeHtml(variantId)}"
      >
        ${escapeHtml(getUseRewardLabel())}
      </button>`
    : `<button
        type="button"
        class="button redemption-history-use-button"
        data-apply-code
        data-reward-code="${escapeHtml(code)}"
        data-reward-label="${escapeHtml(headline)}"
      >
        Apply Code
      </button>`;

  return `
    <div class="redemption-history-item">
      ${media}
      <div class="redemption-history-item__details">
        <div class="redemption-history-item__headline">${escapeHtml(headline)}</div>
        <div class="redemption-history-item__code">Code: ${escapeHtml(code)}</div>
        <div class="redemption-history-item__expiry">
          ${escapeHtml(expiryText)}
          <span class="redemption-history-item__divider">|</span>
          <button type="button" class="redemption-history-copy-button" data-copy-code="${escapeHtml(code)}">Copy Code</button>
        </div>
      </div>
      <div class="redemption-history-item__actions">
        ${primaryAction}
      </div>
    </div>
  `;
}

// Add the reward's linked product to cart and open the cart drawer, and queue the discount code
// in the background at the same time — both happen concurrently since they're independent server
// operations (a cart mutation vs. a session cookie). Known edge case: if the cart-add succeeds but
// the discount-apply fails (or vice versa), a retry click re-adds the product rather than only
// retrying the failed half — acceptable given how rarely one would fail without the other.
async function handleUseRewardClick(button) {
  const code = button.dataset.rewardCode;
  const variantId = button.dataset.rewardVariantId;
  if (!code || !variantId) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Adding…';

  try {
    await Promise.all([addVariantToCartAndOpenDrawer(variantId), applyDiscountCode(code)]);

    button.textContent = originalLabel;
    button.disabled = false;
  } catch (error) {
    console.error('Error using reward:', error);
    button.textContent = 'Try again';
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 2000);
  }
}

// Apply an order-level code (no linked product) in the background, then swap the row's actions
// for a "ready to shop" confirmation instead of navigating away.
async function handleApplyCodeClick(button) {
  const code = button.dataset.rewardCode;
  if (!code) return;

  const originalLabel = button.textContent;
  button.disabled = true;
  button.textContent = 'Applying…';

  try {
    await applyDiscountCode(code);

    const actions = button.closest('.redemption-history-item__actions');
    if (actions) {
      const { message, shopNowLabel, shopNowUrl } = getAppliedCodeSettings();
      const rewardLabel = button.dataset.rewardLabel || 'Your code';

      actions.innerHTML = `
        <div class="redemption-applied-alert">
          <p class="redemption-applied-alert__message">${escapeHtml(message.replace('[reward]', rewardLabel))}</p>
          <a href="${escapeHtml(shopNowUrl)}" class="button redemption-history-shop-now-button">${escapeHtml(shopNowLabel)}</a>
        </div>
      `;
    }
  } catch (error) {
    console.error('Error applying code:', error);
    button.textContent = 'Try again';
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 2000);
  }
}

// Render the Available Rewards list
function renderRedemptionHistory(rewards) {
  const listContainer = document.querySelector('[data-redemption-history-list]');
  const loadingContainer = document.querySelector('[data-redemption-history-loading]');
  const emptyContainer = document.querySelector('[data-redemption-history-empty]');
  const errorContainer = document.querySelector('[data-redemption-history-error]');

  if (!listContainer) return;

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'none';

  if (!rewards || rewards.length === 0) {
    if (emptyContainer) emptyContainer.style.display = 'block';
    listContainer.style.display = 'none';
    return;
  }

  if (emptyContainer) emptyContainer.style.display = 'none';
  listContainer.innerHTML = rewards.map(createRedemptionHistoryItem).join('');
  listContainer.style.display = 'flex';
}

// Show error state for the Rewards History list
function showRedemptionHistoryError() {
  const listContainer = document.querySelector('[data-redemption-history-list]');
  const loadingContainer = document.querySelector('[data-redemption-history-loading]');
  const emptyContainer = document.querySelector('[data-redemption-history-empty]');
  const errorContainer = document.querySelector('[data-redemption-history-error]');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (listContainer) listContainer.style.display = 'none';
  if (emptyContainer) emptyContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'block';
}

// The set of reward codes currently rendered in the My Codes list — used to spot which code is
// new after a redemption refreshes the list.
function getRenderedRewardCodes() {
  return new Set(
    Array.from(document.querySelectorAll('[data-redemption-history-list] [data-copy-code]')).map(
      (element) => element.dataset.copyCode
    )
  );
}

// Briefly flashes the row for a just-redeemed code so the customer sees which reward landed in
// their wallet after the tab switch. The CSS animation (see theme.css) owns the color/timing;
// this just cleans up the class once it's done so re-renders don't inherit it.
function flashRedeemedRow(code) {
  const items = document.querySelectorAll('[data-redemption-history-list] .redemption-history-item');
  const row = Array.from(items).find((item) => item.querySelector('[data-copy-code]')?.dataset.copyCode === code);
  if (!row) return;

  row.classList.add('redemption-history-item--just-redeemed');
  row.addEventListener('animationend', () => row.classList.remove('redemption-history-item--just-redeemed'), {
    once: true,
  });
}

// Redeem a reward, switch to the My Codes tab, and flash the newly-landed code
async function handleRedeemClick(button) {
  const pointsRequired = Number(button.dataset.pointsRequired) || 0;
  const originalLabel = button.textContent;

  button.disabled = true;
  button.textContent = 'Redeeming…';

  const codesBeforeRedeem = getRenderedRewardCodes();

  try {
    const sdk = await window.sdk.onReady();

    // Confirmed against the 99minds SDK docs: https://gist.github.com/mrudult/0fe01a228f1352419dc92e9ef870544c
    const response = await sdk.resource.postRedeemPoints({
      client_customer_id: window.Shopify?.customerId,
      amount: pointsRequired,
    });
    console.log('🎁 Redeem response:', response);

    // The SDK resolves (doesn't reject) even on a business-logic failure like a 400 — success has
    // to be checked explicitly rather than assumed just because the promise resolved.
    if (response?.code && response.code !== 200) {
      throw new Error(response.message || 'Redemption failed');
    }

    await fetchAndUpdatePoints();
    await getRewards();

    // postRedeemPoints()'s own response shape hasn't been directly observed, so the new code is
    // identified by diffing the list before/after the refresh instead — whichever code wasn't
    // there a moment ago is the one that just landed.
    const newCode = Array.from(getRenderedRewardCodes()).find((code) => !codesBeforeRedeem.has(code));

    const subTabs = button.closest('.redemption-subtabs');
    if (subTabs) {
      subTabs.selectedIndex = 1;
    }

    if (newCode) {
      flashRedeemedRow(newCode);
    }

    button.textContent = originalLabel;
    button.disabled = false;
  } catch (error) {
    console.error('Error redeeming reward:', error);
    button.textContent = 'Try again';
    setTimeout(() => {
      button.textContent = originalLabel;
      button.disabled = false;
    }, 2000);
  }
}

// Copy a redeemed reward's code to the clipboard
async function handleCopyCodeClick(button) {
  const code = button.dataset.copyCode;
  if (!code) return;

  try {
    await navigator.clipboard.writeText(code);
    const originalLabel = button.textContent;
    button.textContent = 'Copied!';
    setTimeout(() => {
      button.textContent = originalLabel;
    }, 2000);
  } catch (error) {
    console.error('Error copying code to clipboard:', error);
  }
}

// Delegated click handling for the redemption tab's "Redeem", "Use Reward", "Apply Code", and
// "Copy Code" buttons
function initRedemptionActions() {
  document.addEventListener('click', (event) => {
    const redeemButton = event.target.closest('[data-redeem-button]');
    if (redeemButton && !redeemButton.disabled) {
      handleRedeemClick(redeemButton);
      return;
    }

    const useRewardButton = event.target.closest('[data-use-reward]');
    if (useRewardButton && !useRewardButton.disabled) {
      handleUseRewardClick(useRewardButton);
      return;
    }

    const applyCodeButton = event.target.closest('[data-apply-code]');
    if (applyCodeButton && !applyCodeButton.disabled) {
      handleApplyCodeClick(applyCodeButton);
      return;
    }

    const copyButton = event.target.closest('[data-copy-code]');
    if (copyButton) {
      handleCopyCodeClick(copyButton);
    }
  });
}

// Initialize redemption actions when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initRedemptionActions);
} else {
  initRedemptionActions();
}

// Export for manual testing
window.loyaltyUtils = {
  fetchAndUpdatePoints,
  updateLoyaltyUI,
  updateVipTierDisplay,
  updateRedemptionCardsAvailability,
  renderRedemptionHistory,
  ensureLoyaltyOptIn,
  fetchPointsTransactionHistory,
  getRewards,
  loadTransactionHistory,
  syncBirthdayToMinds,
  logRawLoyaltyData,
};

// ========================================
// How to Redeem Modal
// ========================================

// Cache for prefetched content
let cachedHowToRedeemContent = null;

// Fetch page content
async function fetchPageContent(pageHandle) {
  try {
    const response = await fetch(`/pages/${pageHandle}`);

    if (!response.ok) {
      throw new Error(`Failed to fetch page: ${response.status} ${response.statusText}`);
    }

    const html = await response.text();
    return html;
  } catch (error) {
    console.error('Error fetching page content:', error);
    throw error;
  }
}

// Parse and extract page content
function extractPageContent(html) {
  // Parse the HTML string
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  // Try to find the main page content
  // Shopify page templates typically have the content in .shopify-section or main tags
  let content = doc.querySelector('.shopify-section--main-page .page__content');

  // Fallback selectors if the primary selector doesn't find content
  if (!content) {
    content =
      doc.querySelector('main .page__content') ||
      doc.querySelector('.main-page-wrapper') ||
      doc.querySelector('[data-section-type="page"]') ||
      doc.querySelector('main');
  }

  if (content) {
    // Clone the content to avoid modifying the original
    const contentClone = content.cloneNode(true);

    // Remove footer elements
    const footers = contentClone.querySelectorAll('footer, .footer, [data-section-type="footer"]');
    footers.forEach((footer) => footer.remove());

    // Remove allow-transparent-header attribute to prevent header transparency issues
    const transparentHeaderElements = contentClone.querySelectorAll('[allow-transparent-header]');
    transparentHeaderElements.forEach((element) => element.removeAttribute('allow-transparent-header'));

    return contentClone.innerHTML;
  } else {
    console.warn('Could not find page content in standard locations');
    // Return the full body content as a last resort
    return doc.body.innerHTML;
  }
}

// Show loading state
function showHowToRedeemLoading() {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'flex';
  if (contentContainer) {
    contentContainer.style.display = 'none';
    contentContainer.innerHTML = '';
  }
  if (errorContainer) errorContainer.style.display = 'none';
}

// Show content
function showHowToRedeemContent(content) {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'none';

  if (contentContainer) {
    contentContainer.innerHTML = content;
    contentContainer.style.display = 'block';
  }
}

// Show error state
function showHowToRedeemError() {
  const loadingContainer = document.getElementById('how-to-redeem-loading');
  const contentContainer = document.getElementById('how-to-redeem-content');
  const errorContainer = document.getElementById('how-to-redeem-error');

  if (loadingContainer) loadingContainer.style.display = 'none';
  if (contentContainer) contentContainer.style.display = 'none';
  if (errorContainer) errorContainer.style.display = 'block';
}

// Load and display page content
async function loadHowToRedeemContent(pageHandle, useCache = true) {
  showHowToRedeemLoading();

  try {
    // Use cached content if available
    if (useCache && cachedHowToRedeemContent) {
      showHowToRedeemContent(cachedHowToRedeemContent);
      return;
    }

    const html = await fetchPageContent(pageHandle);
    const content = extractPageContent(html);

    // Cache the content for future use
    cachedHowToRedeemContent = content;

    showHowToRedeemContent(content);
  } catch (error) {
    console.error('Error loading how to redeem content:', error);
    showHowToRedeemError();
  }
}

// Prefetch page content in the background
async function prefetchHowToRedeemContent(pageHandle) {
  try {
    const html = await fetchPageContent(pageHandle);
    const content = extractPageContent(html);
    cachedHowToRedeemContent = content;
  } catch (error) {
    console.error('Error prefetching how to redeem content:', error);
  }
}

// Initialize how to redeem modal
function initHowToRedeemModal() {
  const redeemLink = document.querySelector('[data-how-to-redeem-link]');
  const modal = document.getElementById('how-to-redeem-modal');

  if (!redeemLink || !modal) {
    console.error('How to redeem link or modal not found - feature not configured');
    return;
  }

  const pageHandle = redeemLink.getAttribute('data-page-handle');

  if (!pageHandle) {
    console.error('Page handle not found on how to redeem link');
    return;
  }

  // Prefetch content in the background after a short delay
  setTimeout(() => {
    prefetchHowToRedeemContent(pageHandle);
  }, 1000);

  // Add click handler to link
  redeemLink.addEventListener('click', (e) => {
    e.preventDefault();

    // Open modal
    modal.show();

    // Load page content (will use cache if available)
    loadHowToRedeemContent(pageHandle);
  });
}

// Initialize how to redeem modal when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHowToRedeemModal);
} else {
  initHowToRedeemModal();
}
